module.exports = __webpack_public_path__ + "static/assets/c44ce3bfa465281e765f197d6c3ee7ea.mp3";